import { usePaneLocation } from "@/hooks/pane-routing";

/** Automation id from the open right-pane automation route, or null. */
export function useActiveAutomationId(): string | null {
  const paneLocation = usePaneLocation("rightPane");
  const match = paneLocation?.pathname?.match(/^\/automations\/([^/]+)/);
  const id = match?.[1] ?? null;
  if (!id || id === "new") return null;
  return id;
}
